<template>
  <div v-if="visible" class="ledger-panel">
    <div class="ledger-toolbar">
      <button type="button" class="redeem-link" @click="$emit('open-redeem')">
        <i class="bi bi-gift"></i> 兑换码
      </button>
      <button type="button" class="back-btn" @click="$emit('back')">
        <i class="bi bi-arrow-left"></i> 返回套餐
      </button>
      <span class="ledger-title">点数明细</span>
    </div>

    <div v-if="!records.length" class="ledger-empty">
      <i class="bi bi-receipt"></i>
      <p>暂无点数变动记录</p>
      <span>充值或使用服务后，流水将展示在这里</span>
    </div>

    <div v-else class="ledger-table-wrap">
      <table class="ledger-table">
        <thead>
          <tr>
            <th>时间</th>
            <th>类型</th>
            <th>变动</th>
            <th>余额</th>
            <th>说明</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in records" :key="item.id">
            <td>{{ item.createTime }}</td>
            <td><span class="type-tag" :class="item.type">{{ item.typeLabel }}</span></td>
            <td :class="item.changeAmount >= 0 ? 'plus' : 'minus'">
              {{ item.changeAmount >= 0 ? '+' : '' }}{{ item.changeAmount.toLocaleString() }}
            </td>
            <td>{{ item.balanceAfter.toLocaleString() }}</td>
            <td class="remark">{{ item.remark }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PointsLedgerPanel',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    records: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.ledger-panel {
  display: flex;
  flex-direction: column;
  min-height: 520px;
}

.ledger-toolbar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.redeem-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--primary);
  font-size: 14px;
  font-weight: 500;
}

.redeem-link:hover {
  text-decoration: underline;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--primary);
  font-size: 14px;
}

.back-btn:hover {
  text-decoration: underline;
}

.ledger-title {
  font-size: 18px;
  font-weight: 600;
}

.ledger-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--text-muted);
  padding: 48px 0;
}

.ledger-empty i {
  font-size: 40px;
  opacity: 0.5;
}

.ledger-empty p {
  margin: 0;
  font-size: 15px;
  color: var(--text-secondary);
}

.ledger-table-wrap {
  overflow: auto;
  max-height: 520px;
  border: 1px solid #eef0f4;
  border-radius: 12px;
}

.ledger-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.ledger-table th,
.ledger-table td {
  padding: 12px 14px;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
}

.ledger-table th {
  background: #f5faff;
  color: var(--text-secondary);
  font-weight: 500;
  position: sticky;
  top: 0;
}

.type-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
}

.type-tag.recharge {
  background: #ecfdf5;
  color: #059669;
}

.type-tag.consume {
  background: #fef2f2;
  color: #dc2626;
}

.type-tag.freeze,
.type-tag.unfreeze {
  background: #eff6ff;
  color: #2563eb;
}

.plus {
  color: #059669;
  font-weight: 600;
}

.minus {
  color: #dc2626;
  font-weight: 600;
}

.remark {
  color: var(--text-secondary);
  max-width: 280px;
}
</style>
